import axios from 'axios';

const isPipe = () => {
    try {
        return window.localStorage.getItem('firebase:pipe') || 0;
    } catch(e) {
        return 0;
    }
}

const baseURL = () => {
    const dominio = window.location.hostname;

    // if (dominio == 'localhost' || dominio == '10.0.0.100') {
    //     return 'https://thor.valbets.com';
    // }

    if (dominio.startsWith('valsports') && isPipe() == 3) {
        return 'https://thor.valsports.net';
    }

    if (dominio.startsWith('valbets') && isPipe() == 3) {
        return 'https://thor.valbets.com';
    }

    if (dominio.startsWith("www.")) {
        return dominio.replace("www.", "api.");
    } else {
        return `https://api.${window.location.host}`;
    }
}

const baseTimeout = () => {
    try {
        return isPipe() == 3 ? 900000 : 15000;
    } catch(e) {
        return 15000;
    }
}
 
export const api = axios.create({
    baseURL: baseURL(),
    timeout: baseTimeout()
});

api.interceptors.request.use((config) => {

    const token = (localStorage.getItem('x-token') || undefined);

    config.headers['X-Web-Token'] = true;
    config.headers['X-Access-Token'] = token;

    if (config.method === 'get') {
        const timestamp = new Date().getTime();
        
        // Se já existirem parâmetros na URL, adiciona o novo. Senão, cria.
        if (config.params) {
            config.params['_'] = timestamp;
        } else {
            config.params = { '_': timestamp };
        }
    }

    return config;
}, (error) => {
	return Promise.reject(error);
});

api.interceptors.response.use((response) => {
	return response;
}, (error) => {
	return Promise.reject(error.response);
});